import styled from "styled-components";

import { Form as Unform } from "@unform/web";

export const Container = styled.section`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
  padding: 1.5rem;
  max-width: 43.75rem;

  border-radius: 0.5rem;
  background: ${({ theme }) => theme.checkoutStepsOffers?.cardBackground};

  @media (max-width: 375px) {
    padding: 0;
    background: none;
  }

  .report-with-select-country {
    display: flex;

    margin-bottom: 12px;

    @media (max-width: 450px) {
      flex-direction: column-reverse;
      gap: 25px;
    }
  }
`;

export const Form = styled(Unform)`
  display: flex;
  flex-direction: column;

  width: 100%;
`;
